import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import IccMatrix from './matrix/';
import IccMatrixParameters from './parameters/categoriesValues/edit';
import IccMatrixMadParameters from './parameters/madValues/edit/form';

export const IccMatrixRoutes = [
  {
    'component': <IccMatrix />,
    'path': paths.IccMatrix,
  },
  {
    'component': <IccMatrixParameters />,
    'path': paths.IccParameters,
  },
  {
    'component': <IccMatrixMadParameters />,
    'path': paths.MadParameters,
  },
];
